// extracted by mini-css-extract-plugin
export default {"value_text":"ValueText_value_text__Dogcs","wrapper":"ValueText_wrapper__OQJ7I"};